ScoreTrekBattle.Tournament.Table = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            tables: [],
            resolve: () => {},
            reject: () => {},
            tournament: null,
            eventType: '',
            game: null
        };
    }
    resetStatus();

    function loadActiveTables() {
        return new Promise(function(resolve, reject) {
            Api.request('/battle/tables', {
                gameId: STATUS.game ? STATUS.game.id : null,
                tournamentId: (STATUS.tournament && !STATUS.eventType) ? STATUS.tournament.id : null,
                eventId: (STATUS.tournament && STATUS.eventType) ? STATUS.tournament.id : null,
                eventType: STATUS.eventType || null,
                active: true,
                orderByAvailable: false
            }).then(result => {
                resolve(result.list);
            }).catch(reject);
        });
    }

    function load() {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('Tournament.Table.load', true);
            loadActiveTables().then(tables => {
                STATUS.tables = tables;
                resolve();
            }).catch(reject).finally(() => {
                ScoreTrekBattle.View.loading('Tournament.Table.load', false);
            });
        });
    }

    function render(tableSelectTemplate, tableItemTemplate) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render(tableSelectTemplate, {tournament: STATUS.tournament || {}, game: STATUS.game || {}}).then(view => {
                var tablePromises;

                tablePromises = [];

                STATUS.tables.forEach(table => {
                    tablePromises.push(renderTable(table, tableItemTemplate));
                });

                Promise.all(tablePromises).then(tables => {
                    view.$view.find('[data-id="tables"]').append(tables);
                    resolve(view.$view);
                }).catch(reject);
            });
        });
    }

    function renderFilters(activeFilter) {
        let $filters;

        $filters = $('<div>').addClass('match-filters table-select-filters');

        filters = {
            all: {
                icon: '',
                colorClass: 'color-white'
            },
            available: {
                icon: '<i class="fa-solid fa-play"></i>',
                colorClass: 'color-green'
            },
            occupied: {
                icon: '<i class="fa-solid fa-hourglass-half"></i>',
                colorClass: 'color-light-pink'
            }
        };

        Object.keys(filters).forEach(filterKey => {
            $filters.append(
                $('<span>')
                    .addClass(`match-filter${filters[filterKey].icon ? ' hasIcon' : ''}`)
                    .attr('data-match-filter', filterKey)
                    .append(
                        filters[filterKey].icon,
                        $('<span>').text(__i18n(`table/filter/${filterKey}`))
                    )
                    .on('click', function(event) {
                        event.stopPropagation();
                        event.preventDefault();

                        applyFilter($(this).closest('.table-select-filters'), this.dataset.matchFilter);
                    })
            );
        });

        return $filters;
    }

    function renderTable(table, tableItemTemplate) {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.Template.render(tableItemTemplate, {table: table}).then(view => {
                let isForeign;
                
                isForeign = !table.isAvailable && STATUS.tournament && (table.currentEventId !== STATUS.tournament.id);

                view.$view.on('click', function() {
                    STATUS.dialog.close().then(() => {
                        STATUS.resolve(table);
                    });
                }).attr({
                    'data-is-available': table.isAvailable ? 'yes' : 'no',
                    'data-is-foreign': isForeign ? 'yes' : 'no',
                    'data-has-scoreboard': table.scoreboard ? 'yes' : 'no',
                    'data-is-scoreboard-online': (table.scoreboard && table.scoreboard.isOnline) ? 'yes' : 'no'
                });
                view.$view.find('[data-id="name"]').text(table.name);
                view.$view.find('[data-id="scoreboardName"]').text(table.scoreboard ? table.scoreboard.name : __i18n('table/scoreboard/none'));

                if (table.currentGameId) {
                    view.$view.find('[data-id="matchName"]').append(
                        isForeign ? '<i class="fa-solid fa-square-arrow-up-right"></i> ' : '',
                        $('<span>').text(__i18n('game/name', {number: table.gameInfo.number}))
                    );
                } else {
                    view.$view.find('[data-id="match"]').remove();
                }
                resolve(view.$view);
            }).catch(reject);
        });
    }

    function applyFilter($filters, filterKey, quick) {
        let $activeFilter;

        $activeFilter = $filters.find(`[data-match-filter="${filterKey}"]`);

        if ($activeFilter.length === 0) {
            return;
        }

        $filters.find(`[data-match-filter]`).removeClass('isActive');
        $activeFilter.addClass('isActive');
        
        STATUS.dialog.find(`[data-id="tables"] [data-is-available]`).each(function() {
            let isVisible;

            isVisible = (filterKey === 'all')
                || (filterKey === 'available' && this.dataset.isAvailable === 'yes')
                || (filterKey === 'occupied' && this.dataset.isAvailable === 'no');

            $(this).stop()[isVisible ? 'slideDown' : 'slideUp'](quick ? 0 : 200);
        });
    }

    function show($view, useFilters) {
        let dialogTitle, $title, $filters;

        dialogTitle = STATUS.game ? __i18n('dialog/match/table/title', {gameName: __i18n('game/name', {number: STATUS.game.number})}) : __i18n('table/usage/dialog/title');

        $title = $('<div>').append(dialogTitle);

        if (useFilters) {
            $filters = renderFilters();
            $title.append($filters);
        }

        STATUS.dialog = chmDialog({
            title: $title,
            content: $view,
            paddingTop: false,
            onShow: function() {
                if (useFilters) {
                    applyFilter($filters, 'available', true);
                }
            },
            onEnter: () => {
                var $table;
                $table = $view.find(`[data-id="tables"]${STATUS.game ? ' [data-is-available="yes"]' : ''}`).first();
                if ($table.length > 0) {
                    $table.trigger('click');
                }
            },
            buttons: [
                {
                    label: __i18n('button/cancel'),
                    action: function() {
                        STATUS.reject();
                    }
                }
            ]
        });
    }

    _this = {
        select: function(game) {
            return new Promise(function(resolve, reject) {
                resetStatus();
                STATUS.game = game;

                STATUS.resolve = (table) => {
                    resolve(table);
                    resetStatus();
                };

                STATUS.reject = (error) => {
                    reject(error);
                    resetStatus();
                };

                load().then(() => {
                    return render('tournament/table/select', 'tournament/table/selectItem');
                }).then($view => {
                    show($view, true);
                }).catch(STATUS.reject);
            });
        },
        usage: function(event, eventType) {
            return new Promise(function(resolve, reject) {
                resetStatus();
                STATUS.tournament = event;
                STATUS.eventType = eventType || '';

                STATUS.resolve = (table) => {
                    resolve(table);
                    resetStatus();
                };

                STATUS.reject = (error) => {
                    reject(error);
                    resetStatus();
                };

                load().then(() => {
                    return render('tournament/table/usage', 'tournament/table/usageItem');
                }).then($view => {
                    show($view, false);
                }).catch(STATUS.reject);
            });
        }
    };

    return _this;
})();